import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServiceComponent } from '../../../components/serviceCard/service.component';
@Component({
  selector: 'app-services',
  standalone: true,
  imports: [ServiceComponent,CommonModule],
  templateUrl: './services.component.html',
  styleUrl: './services.component.scss'
})
export class ServicesComponent {

}
